import React from 'react';
import { Button, Tooltip, OverlayTrigger } from 'react-bootstrap5';

import { useContext as useUsersContext } from 'components/Users/Context';

import routes from 'app/routes';

export default function Header() {
  const { state: stateUsers } = useUsersContext();

  const renderTooltip = (props) => (
    <Tooltip {...props}>
      Please, update email first.
    </Tooltip>
  );

  return (
    <section>
      <div className="mb-3 row">
        <div className="col">
          <h1>Activate Your Program</h1>
        </div>
        <div className="col-auto">
          {stateUsers.user.attributes.is_need_change_email
            ? (
              <OverlayTrigger overlay={renderTooltip}>
                <Button className="disabled" style={{ pointerEvents: 'auto' }}>Skip</Button>
              </OverlayTrigger>
            )
            : (
              <a className="btn btn-primary" href={routes.members.programs.index}>Skip</a>
            )}
        </div>
      </div>
    </section>
  );
}
